import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageAddComponent } from './page-add.component';
import { IonicModule } from '@ionic/angular';
import { ToolbarModule } from '../../../routing/navigation/components/toolbar/toolbar.module';
import { IncPageModule } from '../../components/inc-page.module';
import { TranslateModule } from '../../translate/translate.module';

@NgModule({
  declarations: [PageAddComponent],
  imports: [
    CommonModule, IonicModule,
    ToolbarModule,
    IncPageModule,
    TranslateModule
  ], exports: [
    PageAddComponent
  ]
})
export class PageAddModule { }
